export function togglerMenu(IdDiv: string) {
    $(IdDiv).toggleClass("menu-item-open-dropdown menu-item-hover");
}

export function KTUserProfile() {
    document.getElementById("kt_quick_user")?.classList.add("offcanvas-on");

    function removeClass() {
        document
            .getElementById("kt_quick_user")
            ?.classList.remove("offcanvas-on");
    }
    document
        .getElementById("root")
        ?.addEventListener("click", removeClass, true);
    document.getElementById("root")?.removeEventListener("click", removeClass);
}
